<p-toast position="top-right"></p-toast>
<div class="package-Builders p-g">
  <div class="p-g-12">
    <div class="card card-w-title" [ngClass]="{ 'loading': loading }">
      <div *ngIf="loading" class="loader-overlay"><p-progressSpinner [style]="{width: '32px', height: '36px'}"
          styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner></div>
      <h1 class="title">{{setLabel("packageBuilderLabel")}}</h1>
      <p-tabView [activeIndex]="tabIndex" (onChange)="handleTabChange($event)">
        <p-tabPanel [header]='setLabel("activePackagesHeaderLabel")' leftIcon="fa fa-check">
          <p-table [value]="packages" [paginator]="true" [rows]="100" [responsive]="true" [loading]="loading"
            class="p-table-tecfolk-fix">
            <ng-template pTemplate="caption">
              <div class="reportMainFilter">
                <div class="reportMainFields">
                  <div class="filterFields">
                    <span class="fieldTitle">{{setLabel("searchPackageByNameLabel")}}</span>
                    <input pinputtext="" (keyup)="searchLocal(package.packageName)" [(ngModel)]="package.packageName"
                      autocomplete="off" [placeholder]='setLabel("searchHerePlaceholderLabel")' type="text" name="packageName"
                      class="search-input p-inputtext p-corner-all p-state-default p-widget">

                  </div>

                  <div class="reportMainBtn">
                    <span [pTooltip]='setLabel("addNewTooltipLabel")' tooltipPosition="top" [disabled]="loading"
                      routerLink="package-Builder"><i class="pi pi-user-plus"></i></span>
                  </div>
                </div>
                <div class="reportMainBtn">
                  <span [pTooltip]='setLabel("addNewTooltipLabel")' tooltipPosition="top" class="hideOnLaptop" [disabled]="loading"
                    routerLink="package-Builder"><i class="pi pi-user-plus"></i></span>

                  <!-- <button style="background: #ffffff; color: #0e2031;margin-top: 10px; margin-left: 10px;"
                    routerLink="package-Builder"
                    class="p-button p-widget p-state-default p-corner-all p-button-text-only">Add New</button> -->

                  <span *ngIf='this.role.name === "Super Admin" || this.role.name === "Admin" '
                    [pTooltip]='setLabel("exportTooltipLabel")' tooltipPosition="top" [disabled]="loading"
                    [disabled]="!isData" (click)="ExportData(packages , 'Packages_Report')"><i
                      class="fa fa-download"></i></span>

                  <!-- <button (click)="ExportData(packages , 'Packages_Report')"
                    style="margin-left: 25px; background-color: #1ab352; margin-top: 10px;"
                    class="p-button p-widget p-state-default p-corner-all p-button-text-only"
                    *ngIf='this.role.name === "Super Admin" || this.role.name === "Admin" '><i
                      class="fa fa-file-excel-o"></i>&nbsp;Export
                  </button> -->
                </div>

              </div>
              <!-- <span style="color: #ffffff !important">From</span>&nbsp; <p-calendar [yearNavigator]="true"
            yearRange="1950:2040" [monthNavigator]="true" [(ngModel)]="from" placeholder="From Date"
            [inputStyle]="{'color':'#ffffff'}" name="joinDate" [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true">
          </p-calendar>&nbsp;&nbsp;
          <span style="color: #ffffff !important">To</span>&nbsp; <p-calendar [yearNavigator]="true"
            yearRange="1950:2040" [monthNavigator]="true" [(ngModel)]="to" placeholder="To Date"
            [inputStyle]="{'color':'#ffffff'}" name="joinDate" [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true">
          </p-calendar>&nbsp;&nbsp; -->

              <!-- <span style="color: #ffffff !important" *ngIf="selectedOption == 'Member'">Search Package</span>&nbsp; <input
            pinputtext="" *ngIf="selectedOption == 'Member'" [(ngModel)]="tagNumber" autocomplete="off"
            placeholder="Search by TagNumber" type="text" name="tagNumber"
            class="p-inputtext p-corner-all p-state-default p-widget">
          <span style="color: #ffffff !important" *ngIf="selectedOption == 'Visitor'">Search Visitor</span>&nbsp; <input
            pinputtext="" *ngIf="selectedOption == 'Visitor'" [(ngModel)]="visitorContact" autocomplete="off"
            placeholder="Search by Contact" type="text" name="contact"
            class="p-inputtext p-corner-all p-state-default p-widget">
          <span style="color: #ffffff !important" *ngIf="selectedOption == 'Trainer'">Search Trainer</span>&nbsp; <input
            pinputtext="" *ngIf="selectedOption == 'Trainer'" [(ngModel)]="trainer" autocomplete="off"
            placeholder="Search by Name" type="text" name="trainerName"
            class="p-inputtext p-corner-all p-state-default p-widget">&nbsp;&nbsp; -->
              <!-- <button (click)="search()" style="background: #ffffff; color: #0e2031;margin-top: 10px;"
            class="p-button p-widget p-state-default p-corner-all p-button-text-only"><i
              class="fa fa-search"></i>&nbsp;Search</button>&nbsp; -->
              <!-- <button style="background: #ffffff; color: #0e2031;margin-top: 10px;" (click)="resetFilter()"
            class="p-button p-widget p-state-default p-corner-all p-button-text-only">Clear</button> -->

              <!-- <button style="background: #ffffff; color: #0e2031;margin-top: 10px;" (click)="printAllInvoice()"
            class="p-button p-widget p-state-default p-corner-all p-button-text-only"><i class="fa fa-print"
              aria-hidden="true"></i> Print</button> -->
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th style="text-align: left; width: 6em;">{{setLabel("s.NLabel")}}</th>
                <th style="text-align: left;">{{setLabel("packageNameLabel")}}</th>
                <th style="text-align: left;">{{setLabel("packageTypeLabel")}}</th>
                <th style="text-align: left;">{{setLabel("noOfMonthLabel")}}</th>
                <th style="text-align: left;">{{setLabel("noOfMembersLabel")}}</th>
                <th style="text-align: left;">{{setLabel("packageFeeLabel")}}</th>
                <th style="text-align: left;">{{setLabel("registrationFeeLabel")}}</th>
                <th style="text-align: left;">{{setLabel("actionLabel")}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
              <ng-container *ngIf="rowData.isDelete == false">
                <tr>
                  <td style="text-align: left;">
                    <div class="td-title">{{setLabel("s.NLabel")}}</div>
                    <span>{{rowData.sn}}</span>
                  </td>
                  <td style="text-align: left;">
                    <div class="td-title">{{setLabel("packageNameLabel")}}</div>
                    <span>{{rowData.packageName}}</span>
                  </td>
                  <td style="text-align: left; ">
                    <div class="td-title">{{setLabel("packageTypeLabel")}}</div>
                    <span>{{rowData.packageType}}</span>
                  </td>
                  <td style="text-align: left;">
                    <div class="td-title">{{setLabel("noOfMonthLabel")}}</div>
                    <span>{{rowData.noOfMonths}}</span>
                  </td>
                  <td style="text-align: left;">
                    <div class="td-title">{{setLabel("noOfMembersLabel")}}</div>
                    <span>{{rowData.noOfMembers}}</span>
                  </td>
                  <td style="text-align: left;">
                    <div class="td-title">{{setLabel("packageFeeLabel")}}</div>
                    <span>{{rowData.packageFee| number: '1.0-0'}}</span>
                  </td>
                  <td style="text-align: left;">
                    <div class="td-title">{{setLabel("registrationFeeLabel")}}</div>
                    <span>{{rowData.registerationFee| number: '1.0-0'}}</span>
                  </td>
                  <td style=" display: flex; padding-right: 2.2em;">
                    <div class="td-title">{{setLabel("actionLabel")}}</div>
                    <button
                      style=" border-radius: 100% !important; align-items: center; width: 2.143em; height: 2.143em; display: flex;  justify-content: center;"
                      pButton type="button" [pTooltip]='setLabel("deletePackageTooltipLabel")'tooltipPosition="top"
                      class="p-button-danger p-button" icon="fa fa-times" (click)="deletePackage(rowData)"></button>
                    &nbsp;
                    <button
                      style=" border-radius: 100% !important;align-items: center; width: 2.143em; height: 2.143em; display: flex;  justify-content: center;"
                      pButton type="button" [pTooltip]='setLabel("editPackageBuilderDetailsTooltipLabel")' tooltipPosition="top"
                      icon="fa fa-pencil-square-o" (click)="viewPackageBuilder(rowData)"></button>
                  </td>
                </tr>
              </ng-container>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td>
                  {{setLabel("noRecordsFoundLabel")}}
                </td>
              </tr>
            </ng-template>
            <!-- <ng-template pTemplate="summary">
          There are {{sourcePackages?.length}} records
        </ng-template> -->
          </p-table>
        </p-tabPanel>
        <p-tabPanel [header]='setLabel("inActivePackagesHeaderLabel")' leftIcon="fa fa-times">
          <p-table [value]="packages" [paginator]="true" [rows]="100" [responsive]="true" [loading]="loading"
            class="p-table-tecfolk-fix">
            <ng-template pTemplate="caption">
              <div class="reportMainFilter">
                <div class="reportMainFields">
                  <div class="filterFields">
                    <span class="fieldTitle">{{setLabel("searchPackageByNameLabel")}}</span>
                    <input pinputtext="" (keyup)="searchLocal(package.packageName)" [(ngModel)]="package.packageName"
                      autocomplete="off" [placeholder]='setLabel("searchHerePlaceholderLabel")' type="text" name="packageName"
                      class="search-input p-inputtext p-corner-all p-state-default p-widget">

                  </div>

                  <div class="reportMainBtn">
                    <span [pTooltip]='setLabel("addNewTooltipLabel")' tooltipPosition="top" [disabled]="loading"
                      routerLink="package-Builder"><i class="pi pi-user-plus"></i></span>
                  </div>
                </div>
                <div class="reportMainBtn">
                  <span [pTooltip]='setLabel("addNewTooltipLabel")' tooltipPosition="top" class="hideOnLaptop" [disabled]="loading"
                    routerLink="package-Builder"><i class="pi pi-user-plus"></i></span>

                  <!-- <button style="background: #ffffff; color: #0e2031;margin-top: 10px; margin-left: 10px;"
                    routerLink="package-Builder"
                    class="p-button p-widget p-state-default p-corner-all p-button-text-only">Add New</button> -->

                  <span *ngIf='this.role.name === "Super Admin" || this.role.name === "Admin" '
                    [pTooltip]='setLabel("exportTooltipLabel")' tooltipPosition="top" [disabled]="loading"
                    [disabled]="!isData" (click)="ExportData(packages , 'Packages_Report')"><i
                      class="fa fa-download"></i></span>

                  <!-- <button (click)="ExportData(packages , 'Packages_Report')"
                    style="margin-left: 25px; background-color: #1ab352; margin-top: 10px;"
                    class="p-button p-widget p-state-default p-corner-all p-button-text-only"
                    *ngIf='this.role.name === "Super Admin" || this.role.name === "Admin" '><i
                      class="fa fa-file-excel-o"></i>&nbsp;Export
                  </button> -->
                </div>

              </div>
              <!-- <div class="searchMain">
                <input pinputtext="" style="color: #ffffff ;" (keyup)="searchLocal(package.packageName)"
                  [(ngModel)]="package.packageName" autocomplete="off" placeholder="Search Package" type="text"
                  name="packageName" class="p-inputtext p-corner-all p-state-default p-widget">
                &nbsp;
                &nbsp;
                <button style="background: #ffffff; color: #0e2031;margin-top: 10px; margin-left: 10px;"
                  routerLink="package-Builder"
                  class="p-button p-widget p-state-default p-corner-all p-button-text-only">Add New</button>

                <button (click)="ExportData(packages , 'Packages_Report')"
                  style="margin-left: 25px; background-color: #1ab352; margin-top: 10px;"
                  class="p-button p-widget p-state-default p-corner-all p-button-text-only"
                  *ngIf='this.role.name === "Super Admin" || this.role.name === "Admin" '><i
                    class="fa fa-file-excel-o"></i>&nbsp;Export
                </button>
              </div> -->
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th style="text-align: left; width: 6em;">{{setLabel("s.NLabel")}}</th>
                <th style="text-align: left;">{{setLabel("packageNameLabel")}}</th>
                <th style="text-align: left;">{{setLabel("packageTypeLabel")}}</th>
                <th style="text-align: left;">{{setLabel("noOfMonthLabel")}}</th>
                <th style="text-align: left;">{{setLabel("noOfMembersLabel")}}</th>
                <th style="text-align: left;">{{setLabel("packageFeeLabel")}}</th>
                <th style="text-align: left;">{{setLabel("registrationFeeLabel")}}</th>
                <th style="text-align: left;">{{setLabel("actionLabel")}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
              <ng-container *ngIf="rowData.isDelete == true">
                <tr>
                  <td style="text-align: left;">
                    <div class="td-title">{{setLabel("s.NLabel")}}</div>
                    <span>{{rowData.sn}}</span>
                  </td>
                  <td style="text-align: left;">
                    <div class="td-title">{{setLabel("packageNameLabel")}}</div>
                    <span>{{rowData.packageName}}</span>
                  </td>
                  <td style="text-align: left; ">
                    <div class="td-title">{{setLabel("packageTypeLabel")}}</div>
                    <span>{{rowData.packageType}}</span>
                  </td>
                  <td style="text-align: left;">
                    <div class="td-title">{{setLabel("noOfMonthLabel")}}</div>
                    <span>{{rowData.noOfMonths}}</span>
                  </td>
                  <td style="text-align: left;">
                    <div class="td-title">{{setLabel("noOfMembersLabel")}}</div>
                    <span>{{rowData.noOfMembers}}</span>
                  </td>
                  <td style="text-align: left;">
                    <div class="td-title">{{setLabel("packageFeeLabel")}}</div>
                    <span>{{rowData.packageFee}}</span>
                  </td>
                  <td style="text-align: left;">
                    <div class="td-title">{{setLabel("registrationFeeLabel")}}</div>
                    <span>{{rowData.registerationFee}}</span>
                  </td>
                  <td style=" display: flex; padding-right: 2.2em;">
                    <div class="td-title">{{setLabel("actionLabel")}}</div>
                    <!-- <button
                style=" border-radius: 100% !important; align-items: center; width: 2.143em; height: 2.143em; display: flex;  justify-content: center;"
                pButton type="button" pTooltip="Activate Package" class="p-button-success p-button" icon="fa fa-check"
                (click)="activatePackage(rowData)"></button> &nbsp; -->
                    <button
                      style=" border-radius: 100% !important;align-items: center; width: 2.143em; height: 2.143em; display: flex;  justify-content: center;"
                      pButton type="button" [pTooltip]='setLabel("editPackageBuilderDetailsTooltipLabel")' tooltipPosition="top"
                      icon="fa fa-pencil-square-o" (click)="viewPackageBuilder(rowData)"></button>
                  </td>
                </tr>
              </ng-container>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td>
                  {{setLabel("noRecordsFoundLabel")}}
                </td>
              </tr>
            </ng-template>
            <!-- <ng-template pTemplate="summary">
          There are {{sourcePackages?.length}} records
        </ng-template> -->
          </p-table>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>